module.exports = __webpack_public_path__ + "static/media/team-4.23007132.jpg";